import { Component, EventEmitter, HostBinding, Input, OnInit, Output, ViewChild } from '@angular/core'
import { AbstractControl, FormArray, FormControl, FormGroup, Validators } from '@angular/forms'
import * as lodash from 'lodash'
import { Destroyable, untilDestroy } from '@tokeet-frontend/tv3-platform'
import { defaultSignerOrderValue } from '../signing-order-editor/signing-order-editor.component'
import { FormRoleInputComponent } from '@tv3/containers/documents/templates/template-drawer/components/form-role-input/form-role-input.component'

export function duplicatedRoleValidator(rolesForm: FormArray, field: string = 'role') {
  return (roleCtrl: AbstractControl) => {
    const value = roleCtrl.value
    if (!value) {
      return undefined
    }
    const roleForms = rolesForm.controls

    const isDuplicated = lodash.some(roleForms, (form: FormGroup) => {
      const ctrl = form.get(field)
      return roleCtrl !== ctrl && ctrl.value === value
    })

    if (isDuplicated) {
      return { duplicated: true }
    }
  }
}

export function newRoleItemForm(
  rolesForm: FormArray,
  data?: { role?: string; idPhotoRequired?: boolean; selfiePhotoRequired?: boolean; order?: number }
) {
  return new FormGroup({
    role: new FormControl(data?.role, [Validators.required, duplicatedRoleValidator(rolesForm)]),
    order: new FormControl(data?.order || defaultSignerOrderValue),
    id_photo_required: new FormControl(data?.idPhotoRequired),
    selfie_photo_required: new FormControl(data?.selfiePhotoRequired),
  })
}

@Component({
  selector: 'app-role-item-form',
  templateUrl: './role-item-form.component.html',
  styleUrls: ['./role-item-form.component.scss'],
})
export class RoleItemFormComponent extends Destroyable implements OnInit {
  @ViewChild('roleInput') roleInput: FormRoleInputComponent
  @Input() form: FormGroup

  @HostBinding('class.editable')
  @Input()
  isRoleEditable = true
  @Input() removable = true

  @Output() roleSelect = new EventEmitter<string>()
  @Output() remove = new EventEmitter()

  get idPhotoCtrl() {
    return this.form?.get('id_photo_required') as FormControl
  }

  get selfiePhotoCtrl() {
    return this.form?.get('selfie_photo_required') as FormControl
  }

  constructor() {
    super()
  }

  ngOnInit(): void {
    this.form
      .get('role')
      .statusChanges.pipe(untilDestroy(this))
      .subscribe(() => {
        this.roleInput?.markTouched()
      })
  }

  get isIdPhotoRequired() {
    return !!this.idPhotoCtrl.value
  }

  get isSelfiePhotoRequired() {
    return !!this.selfiePhotoCtrl.value
  }

  toggleIdPhoto() {
    this.idPhotoCtrl.setValue(!this.idPhotoCtrl.value)
  }

  toggleSelfiePhoto() {
    this.selfiePhotoCtrl.setValue(!this.selfiePhotoCtrl.value)
  }

  getPhotosRequirementDescription() {
    if (!this.isIdPhotoRequired && !this.isSelfiePhotoRequired) {
      return $localize`Both national ID & Selfie Not Required`
    } else if (this.isIdPhotoRequired && !this.isSelfiePhotoRequired) {
      return $localize`Only National ID is Required`
    } else if (!this.isIdPhotoRequired && this.isSelfiePhotoRequired) {
      return $localize`Only Selfie is Required`
    } else {
      return $localize`Both National ID & Selfie are Required`
    }
  }

  onRemove() {
    this.remove.emit()
  }

  onRoleSelect(role: string) {
    this.roleSelect.emit(role)
  }
}
